import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import Error from "../../../components/common/error/Error";
import Api from "../../components/api/Api";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import AdminHeader from "../../common/Header";
const AddUser = ({ userTypePartner }) => {
  const loggedInUser = useSelector((state) => state.auth);

  const userType = loggedInUser?.user?.user?.userType?.name;
  console.log(userType);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const initialValues = {
    user_name: "",
    first_name: "",
    last_name: "",
    email_address: "",
    mobile_number: "",
    userType: {},
    role: [],
  };
  useEffect(() => {
    if (userType === "SUPER_ADMIN") {
      setSelectedUserType({ value: "", label: "Select User Type" });
    } else if (userType === "PARTNER") {
      setSelectedUserType({ value: { name: "PARTNER" }, label: "Partner" });
    } else if (userType === "CUSTOMER") {
      setSelectedUserType({ value: { name: "CUSTOMER" }, label: "Customer" });
    }
  }, [userType]);
  const getDetailsApi = Api({
    url: `admin/addUser`,
  });
  const handleSubmit = async (values, { setSubmitting }) => {
    const roleValues = selectedRoles.map((option) => option.value);
    console.log(roleValues);
    console.log(values);

    try {
      setSubmitting(true);
      console.log(userTypePartner);
      const data = {
        user_name: "",
        first_name: values.first_name,
        last_name: values.last_name,
        email_address: values.email_address,
        mobile_number: values.mobile_number,
        userType: selectedUserType.value,
        role: roleValues,
      };

      console.log(data);
      const responseData = await getDetailsApi.postData(data);
      console.log(responseData);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("User added successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/user");
        }, 3000);
      } else {
        showToast(responseData.data.text || "Error Addiing User", {
          type: "error",
        });
      }
      console.log(data);
    } catch (error) {
      setIsError(true);
      showToast("Error Occured", {
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    mobile_number: Yup.string()
      .matches(/^(?:\+91|91)?[6-9]\d{9}$/, "Please enter a valid mobile number")
      .required("Mobile Number is required"),
  });

  const rolesOptions = [
    { value: "ROLE_ADMIN", label: "Admin" },
    { value: "ROLE_LEAD", label: "Lead" },
    { value: "ROLE_TEAM_MEMBER", label: "Team Member" },
    { value: "ROLE_FRONT_DESK", label: "Front Desk" },
    { value: "ROLE_USER", label: "User" },
  ];

  const userTypesOptions = [
    { value: "", label: "Select User Type" },
    { value: { name: "ALL_HOME_DESIRE" }, label: "All Home Desire" },
    { value: { name: "PARTNER" }, label: "Partner" },
    { value: { name: "CUSTOMER" }, label: "Customer" },
  ];

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Team Management", link: "/user" },
    { label: "Add User Details", link: "", active: true },
  ];
  console.log("your selelcted user type is ", selectedUserType);
  return (
    <div className="user-page">
      <div className="user-page__inner">
        <aside className="user-page__sidebar">
          <AdminHeader />
        </aside>

        <main className="user-page__content">
          <div className="user-page__header">
            <div>
              <span className="user-page__eyebrow">User Management</span>
              <h1 className="user-page__title">Add User</h1>
            </div>
          </div>

          <div className="user-page__card">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="add-user__form">
                  <div className="add-user__grid">
                    <div className="add-user__field">
                      <label>First Name</label>
                      <Field
                        type="text"
                        name="first_name"
                        placeholder="Enter First Name"
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="add-user__error"
                      />
                    </div>

                    <div className="add-user__field">
                      <label>Last Name</label>
                      <Field
                        type="text"
                        name="last_name"
                        placeholder="Enter Last Name"
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="add-user__error"
                      />
                    </div>
                  </div>

                  <div className="add-user__grid">
                    <div className="add-user__field">
                      <label>Email Address</label>
                      <Field
                        type="email"
                        name="email_address"
                        placeholder="Enter Email"
                      />
                      <ErrorMessage
                        name="email_address"
                        component="div"
                        className="add-user__error"
                      />
                    </div>

                    <div className="add-user__field">
                      <label>Mobile Number</label>
                      <Field
                        type="text"
                        name="mobile_number"
                        placeholder="Enter Phone Number"
                      />
                      <ErrorMessage
                        name="mobile_number"
                        component="div"
                        className="add-user__error"
                      />
                    </div>
                  </div>

                  {userType === "SUPER_ADMIN" && (
                    <div className="add-user__field">
                      <label>User Type</label>
                      <Select
                        options={userTypesOptions}
                        onChange={setSelectedUserType}
                        value={selectedUserType}
                        placeholder="Select User Type"
                      />
                    </div>
                  )}

                  {selectedUserType?.value?.name !== "CUSTOMER" && (
                    <div className="add-user__field">
                      <label>Role</label>
                      <Select
                        options={rolesOptions}
                        isMulti
                        onChange={setSelectedRoles}
                        value={selectedRoles}
                        placeholder="Select Role"
                      />
                    </div>
                  )}

                  <button
                    type="submit"
                    className="user-page__btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <Spinner loading /> : "Add User"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddUser;
